import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "RequestContactButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, showFreeDialogForSite} = useTextareaComponent();

async function requestContact() {
    if (!showFreeDialogForSite()) {
        let p: OperatorApplicationApi.OperatorMessageRequestContactOpenApiModel = {
            username: client.value.username
        };
        let result = await (new OperatorApiRequest({
            url: "/message/requestContact",
            p
        })).send();
        result.showMessageOnError();
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(client).isRequestContactAvailable)
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: "address-card",
        tooltip: _unref(__)('Запросить контакт'),
        onClick: requestContact
      }, null, 8, ["tooltip"]))
    : _createCommentVNode("", true)
}
}

})